
import { Route } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import ContactsPage from "@/pages/contacts/ContactsPage";
import ContactCreatePage from "@/pages/contacts/ContactCreatePage";
import ContactEditPage from "@/pages/contacts/ContactEditPage";

export function ContactRoutes() {
  return (
    <>
      <Route 
        path="/contacts" 
        element={
          <ProtectedRoute>
            <ContactsPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/contacts/new" 
        element={
          <ProtectedRoute>
            <ContactCreatePage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/contacts/:id" 
        element={
          <ProtectedRoute>
            <ContactEditPage />
          </ProtectedRoute>
        } 
      />
    </>
  );
}
